import React,{Component} from "react";
import ContactForm from '../components/contactusForm/contactusForm.js';

class Mailer extends React.Component{
  constructor(){
    super();
  }
  openMailer(){
    window.open("mailto:?cc=&subject=&body=");
  }
  render(){
    return(
      <div className="content_sections contact">
        <h1>Contact</h1>
        <span>If you have any questions or comments feel free to contact me using the form below or email me directly:<a href="mailto:boris@livshutz.com"  className="email_boris"> boris@livshutz.com</a></span>
        <ContactForm/>
        <br/>
        <br/>
       
      </div>
    )
    
  }
}
export default Mailer



// WEBPACK FOOTER //
// ./src/pages/contact.js